"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDwar = void 0;
const ensure_string_1 = require("ensure-string");
const getParts_1 = require("./utils/getParts");
const parseColumnbProperties_1 = require("./utils/parseColumnbProperties");
const parseData_1 = require("./utils/parseData");
/**
 * Convert a DataWarrior database into a JSON object
 * @param {string} text
 * @returns
 */
function parseDwar(text) {
    text = (0, ensure_string_1.ensureString)(text);
    const parts = (0, getParts_1.getParts)(text);
    improveParts(parts);
    return parts;
}
exports.parseDwar = parseDwar;
function improveParts(parts) {
    for (const key in parts) {
        switch (key) {
            case 'columnProperties':
                parts[key] = (0, parseColumnbProperties_1.parseColumnbProperties)(parts[key]);
                break;
            case 'data':
                break;
            default:
                parts[key] = parseDefault(parts[key]);
        }
    }
    const data = (0, parseData_1.parseData)(parts.data, {
        columnProperties: parts.columnProperties,
    });
    parts.data = data.entries;
    parts.rawData = data.rawEntries;
}
function parseDefault(lines) {
    const result = {};
    for (const line of lines) {
        const [key, value] = line.slice(1, -1).split('=');
        result[key] = value.slice(1, -1);
    }
    return result;
}
//# sourceMappingURL=parseDwar.js.map